import React from 'react';
import dayjs from 'dayjs';
import { convertToLocalTime } from '../../commonFunctions/commonFunctions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { blockCase } from '../../redux/currentCase/thunks';
import { Chip } from '@material-ui/core';
import { Attachment } from '@material-ui/icons';
import { Box } from 'devextreme-react';

function Comment(props) {
  const { message, date, agent, state, showCommentInfo = true, titleFontSize, commentFontSize, files, downloadHistoryFile } = props;
  return (
    <div>
      {showCommentInfo && (
        <div style={{ fontSize: titleFontSize }} className="firmaHistorico">
          <span>{dayjs(convertToLocalTime(date)).format('DD/MM/YYYY HH:mm')}</span> - <span className="agent-name">{agent}</span>
          <span> - {state}</span>
        </div>
      )}
      {files != null && files.length > 0 && (
        <div className="firmaHistorico firmaHistoricoFiles">
          {/* <hr></hr> */}
          <div sx={{ display: 'flex', flexWrap: 'wrap', gap: ".4rem", padding: ".4rem", borderTop: '1px solid black' }}>
              {files.map((file) => (
                <Chip
                  key={file.caseTraceFileId}
                  label={file.fileName}
                  title={file.fileName}
                  size="small"
                  icon={<Attachment sx={{ fontSize: '0.75rem !important' }} />}
                  sx={{ borderRadius: '2px', bgcolor: '#275aa7', height: 22, fontSize: '0.7rem', fontWeight: 600 }}
                  onClick={(e) => downloadHistoryFile(file.blobGuid)}
                />
              ))}
            </div>
        </div>
      )}
      <div style={{ fontSize: commentFontSize }} className="comment" dangerouslySetInnerHTML={{ __html: message }} />
    </div>
  );
}

export { Comment };
